export interface ISubTopicsState {
  title: string;
  url: string;
  list: Array<{
    id: number;
    url: string;
    title: string;
    hasVideo: boolean;
    isNew: boolean;
    isLive: boolean;
  }>;
}
const initialState: ISubTopicsState = {
  title: '',
  url: '',
  list: []
};
export default (state: ISubTopicsState = initialState) => {
  return state;
};
